import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueApexCharts from "vue3-apexcharts";
import { createPinia } from "pinia";
import "./assets/tailwind.css";
import "./assets/animate.css";
import "./assets/sass/css/windzo.css";
import "./assets/design-system.css";
import vClickOutside from "click-outside-vue3";

// Vue Toastification
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

// Solo cargar config del tenant (sin aplicar al DOM)
import { cargarConfigTenant, obtenerConfigTenant } from "@/utils/tenantConfig";

const app = createApp(App);

// ============================================================
// CARGAR CONFIG DEL TENANT EN MEMORIA (NO AL DOM)
// ============================================================
const tenantIdGuardado =
  localStorage.getItem("tenantId") || obtenerConfigTenant()?.idEmpresa;

if (tenantIdGuardado) {
  cargarConfigTenant(tenantIdGuardado).catch((err) => {
    console.warn("⚠️ No se pudo cargar la config del tenant:", err);
  });
}

// ============================================================
// CONFIGURACIÓN DE VUE TOASTIFICATION
// ============================================================
app.use(Toast, {
  position: "top-right",
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
  transition: "Vue-Toastification__bounce",
  maxToasts: 5,
  newestOnTop: true,
  filterBeforeCreate: (toast, toasts) => {
    if (toasts.filter((t) => t.type === toast.type).length >= 3) {
      return false;
    }
    return toast;
  },
});

app.use(router);
app.use(createPinia());
app.use(VueApexCharts);
app.use(vClickOutside);

app.mount("#app");

// ✅ ELIMINADO: arreglarToastification() + setTimeouts + MutationObserver.
// El fix de pointer-events ya está en el CSS de App.vue
// (.Vue-Toastification__container { pointer-events: none !important })
// y el observer sobre document.body con subtree:true causaba jank
// en cada cambio del DOM.